import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEcomGiftCardsSpiHostV1GiftCardsSpiHostServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/gift-cards-spi-host',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/ecom/v1/gift-cards',
        destPath: '/v1/gift-cards',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/ecom/v1/gift-cards',
        destPath: '/v1/gift-cards',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_ecom_gift-vouchers';

/** Retrieves a gift card. */
export function getGiftCard(payload: object): RequestOptionsFactory<any> {
  function __getGiftCard({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.v1.gift_card',
      method: 'POST' as any,
      methodFqn:
        'wix.ecom.gift_cards_spi_host.v1.GiftCardsSpiHostService.GetGiftCard',
      packageName: PACKAGE_NAME,
      url: resolveWixEcomGiftCardsSpiHostV1GiftCardsSpiHostServiceUrl({
        protoPath: '/v1/gift-cards/{code}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __getGiftCard;
}

/**
 * Redeems a gift card.
 * Creates a transaction and lowers the card balance by the transaction amount.
 */
export function redeemGiftCard(payload: object): RequestOptionsFactory<any> {
  function __redeemGiftCard({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.v1.gift_card',
      method: 'POST' as any,
      methodFqn:
        'wix.ecom.gift_cards_spi_host.v1.GiftCardsSpiHostService.RedeemGiftCard',
      packageName: PACKAGE_NAME,
      url: resolveWixEcomGiftCardsSpiHostV1GiftCardsSpiHostServiceUrl({
        protoPath: '/v1/gift-cards/redeem',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __redeemGiftCard;
}

/**
 * Voids a gift card transaction.
 * Transaction IDs are returned in Redeem Gift Card.
 */
export function voidTransaction(payload: object): RequestOptionsFactory<any> {
  function __voidTransaction({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.v1.gift_card',
      method: 'POST' as any,
      methodFqn:
        'wix.ecom.gift_cards_spi_host.v1.GiftCardsSpiHostService.VoidTransaction',
      packageName: PACKAGE_NAME,
      url: resolveWixEcomGiftCardsSpiHostV1GiftCardsSpiHostServiceUrl({
        protoPath: '/v1/gift-cards/void',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __voidTransaction;
}
